import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { PageLoader } from '@/components/feedback/PageLoader'
import { paths } from '@/app/router/paths'
import { useAuthStatus } from '@/stores/authStore'

/**
 * Gate for everything behind sign-in. While the session is being restored we
 * hold the screen rather than flashing the login page at a signed-in user.
 */
export function ProtectedRoute() {
  const status = useAuthStatus()
  const location = useLocation()

  if (status === 'loading') return <PageLoader />

  if (status === 'anonymous') {
    return (
      <Navigate
        to={paths.login}
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    )
  }

  return <Outlet />
}
